import { render, staticRenderFns } from "./EConteudoAulaPolivalente.vue?vue&type=template&id=984b9198&scoped=true"
import script from "./EConteudoAulaPolivalente.vue?vue&type=script&lang=js"
export * from "./EConteudoAulaPolivalente.vue?vue&type=script&lang=js"
import style0 from "./EConteudoAulaPolivalente.vue?vue&type=style&index=0&id=984b9198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984b9198",
  null
  
)

export default component.exports